<section>
    <div class="container">
        <div class="columns is-mobile lender-row">
            <div
                class="column is-one-quarter-desktop is-half-touch has-text-centered"
            >
                <ul>
                    <li>
                        <a
                            [href]="listing.form_url"
                            target="_blank"
                        >
                            <img
                                *ngIf="listing.logo_name; else useS3Logo"
                                class="lender-logo"
                                [src]="'/application/views/www/public/assets/img/' + listing.logo_name"
                                [alt]="listing.bank_name"
                            >
                            <ng-template #useS3Logo>
                                <img
                                    class="lender-logo"
                                    [src]="s3Logo + '300x100/' + listing.client_id.toLowerCase() + '.png?' + time()"
                                    [alt]="listing.bank_name"
                                    (error)="getWasabiLogo($event)"
                                >
                            </ng-template>
                        </a>
                    </li>
                    <div *ngIf="listing.total_reviews" class="review-total-stars">
                        <div class="review-total-stars">
                            <li>
                                <i *ngFor="let star of [].constructor(floor(listing.overall_rating)); let i = index" class="fas fa-star has-text-link"></i>
                                <i *ngIf="floor(listing.overall_rating ) != listing.overall_rating" class="fas fa-star-half-alt has-text-link"></i>
                                <ng-template *ngIf="4 - floor(listing.overall_rating) >= 0">
                                    <i *ngFor="let star of [].constructor(4 - floor(listing.overall_rating)); let i = index" class="far fa-star has-text-link"></i>
                                </ng-template>
                                <span class="lender-rating tag is-link is-size-7 is-hidden-touch">
                                    {{ listing.overall_rating  + ' out of 5' }}
                                </span>
                            </li>
                            <li class="review-total">
                                <div *ngIf="listing.total_reviews > 0; else internalReviews">
                                  <div class="review-proof">{{ listing.review_source }}</div>
                                  {{ listing.total_reviews + ' Verified Reviews' }}
                                </div>
                                <ng-template #internalReviews>
                                    <div>
                                        Internal Reviews
                                    </div>
                                </ng-template>
                            </li>
                        </div>
                    </div>
                </ul>
            </div>
            <div
                class="column is-half-touch" style="font-size: 13px; margin-left: 0px;"
            >
                <div *ngIf="listing.marketing_text">
                    <ul>
                        <li *ngFor="let text of listing.marketing_text; index as i" [class]="i >= 2 ? 'is-hidden-touch' : ''">
                            <i class="fas fa-check has-text-link"></i> {{ text }}
                        </li>
                    </ul>
                    <p *ngIf="listing.form_link" class="is-hidden-touch" style="margin-top: 10px">
                            <a
                                class="is-uppercase"
                                [href]="listing.form_url"
                                target="_blank"
                            >
                                {{ 'See ' + listing.bank_name + ' Deal' }}
                                <i class="fas fa-chevron-right"></i>
                            </a>
                    </p>
                    <a
                        *ngIf="listing.form_link"
                        class="button is-link is-medium is-hidden-desktop"
                        style="margin-bottom: 5px;"
                        [href]="listing.form_url"
                        target="_blank"
                    >
                        View Rates
                        <i class="fas fa-chevron-right" style="margin-left: 5px"></i>
                    </a>
                    <div *ngIf="listing.form_link && !isTopTenBestLenders">
                        <a
                            class="button is-link is-medium is-hidden-desktop call-btn"
                            [href]="'tel:' + (listing.phone ? listing.phone : officeStatus.phone)"
                            target="_blank"
                            [style.visibility]="officeStatus.answer ? '' : 'hidden'"
                        >
                            Call Us
                        </a>
                    </div>
                </div>
            </div>
            <div class="column is-one-quarter-desktop has-text-right-desktop has-text-centered-touch is-hidden-touch">
                <a
                    *ngIf="listing.form_link"
                    class="button is-link is-medium"
                    style="margin-bottom: 5px;"
                    [href]="listing.form_url"
                    target="_blank"
                >
                    View Rates
                    <i class="fas fa-chevron-right" style="margin-left: 5px"></i>
                </a>
                <div *ngIf="listing.form_link && !isTopTenBestLenders">
                    <a
                        class="button is-link is-medium call-btn"
                        [href]="'tel:' + (listing.phone ? listing.phone : officeStatus.phone)"
                        target="_blank"
                        [style.visibility]="officeStatus.answer ? '' : 'hidden'"
                    >
                        Call Us
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
